<div class="card-text">
    @if (!isEdited(basicInfoForm)) {
        <app-session-basic-info [form]="basicInfoForm"></app-session-basic-info>
    }
    @if (isEdited(basicInfoForm)) {
        <app-session-basic-info-edit
            [context]="context"
            [form]="basicInfoForm"
        ></app-session-basic-info-edit>
    }

    <!-- <app-time-variants-list [form]="timeVariantsForm"></app-time-variants-list> -->
    <app-day-variants-list [form]="dayVariantsForm"></app-day-variants-list>
    <app-options-list
        [form]="optionsForm"
        [context]="context"
    ></app-options-list>

    @if (isPricingMatrixVisible) {
        <div>
            <app-pricing-matrix [form]="pricingMatrixForm"></app-pricing-matrix>
        </div>
    }
</div>
